Namespace 'Monitoring.Views.Charts'

class Monitoring.Views.Charts.VueWidgetWrapper extends Monitoring.Views.Charts.ChartView

  className: 'item'

  events:
    'click #save_note': 'saveNote'
    'click #delete_note': 'deleteNote'

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @_settings = @options.settings
    widgetOptions = @options.options or {}
    widgetDefaultOptions = { editableTitle: false, readonly: @options.readonly, enableNotes: true }

    @vueSortableBoundWidget = new VueInBackbone.VueComponent('sortable-bound-widget', {
      widget: @options.widget,
      title: @options.title,
      menu: @options.menu,
      isLoading: true,
      data: @options.data or {},
      error: null,
      options: $.extend({}, widgetDefaultOptions, widgetOptions),
    })

    @menuEvents = {}
    @widgetEvents = {}

  render: ->
    @$el.html(@vueSortableBoundWidget.el)
    @vueSortableBoundWidget.render()
    @bindCommonEvents(@vueSortableBoundWidget)
    @

  bindCommonEvents: ->
    @vueSortableBoundWidget.on('show-note', @displayNote)
    @vueSortableBoundWidget.on('move-up', @moveUp)
    @vueSortableBoundWidget.on('move-down', @moveDown)
    @vueSortableBoundWidget.on('close', @destroy)
    @vueSortableBoundWidget.on('click-menu', @clickMenu)
    @vueSortableBoundWidget.on('widget-event', @widgetEvent)
    @vueSortableBoundWidget.on('retry', @retry)

  retry: =>
    @vueSortableBoundWidget.update({
      isLoading: true,
      error: null
    })
    @afterAppend()

  moveUp: =>
    @trigger('sortAsc', { currentTarget: @vueComponentElement() })

  moveDown: =>
    @trigger('sortDesc', { currentTarget: @vueComponentElement() })

  vueComponentElement: =>
    @vueSortableBoundWidget.vueComponent.$el

  clickMenu: (data) =>
    @menuEvents[data.event](data.value)

  widgetEvent: (data) =>
    @widgetEvents[data.event](data.value)

  addLinkToNote: ->

  _displayError: ({message, allowRetry}) =>
    @vueSortableBoundWidget.update({
      isLoading: false,
      error: {
        message: message,
        allowRetry: allowRetry
      }
    })

  destroy: =>
    @vueSortableBoundWidget.remove()
    super()
